

import React from "react";
import '../src/components/css/style.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./pages/Home"; 
import ProjectPage from "./pages/ProjectPage";
import Login from "./pages/Login";
import ProjectPageCalander from "./pages/ProjectPageCalander";
import Register from "./pages/Register";
import ActivityLog from "./components/ActivityLog";
import Chat from "./components/Chat";



import UserLogin from "./User/UserLogin";
import UserDashboard from "./User/UserDashboard";
import UserChat from "./User/UserChat";
import KpiDashboard from "./compo/KpiDashboard";
import ExportData from "./compo/ExportData";
import AdminLoginAccess from "./pages/AdminLoginAccess";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import SharedAccess from "./pages/SharedAccess";
import SharedAccessNew from "./pages/SharedAccessNew";
import UserOperation from "./User/UserOperation";
import UserStrategic from "./User/UserStrategic";
import UserProject from "./User/UserProject";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
      
        <Routes>

          <Route path="/dashboard" element={<Home />} />
          <Route path="/" element={<Login />} />
          <Route path="/project-detail/:id/:title" element={<ProjectPage />} />
          <Route path="/project-detail-calander/:id/:title" element={<ProjectPageCalander />} />
          <Route path="/create-account" element={<Register />} />
          <Route path="/logs" element={<ActivityLog />} />
          <Route path="/chats" element={<Chat />} />
          <Route path="/kpi-dashboard" element={<KpiDashboard />} />
          <Route path="/export-reports" element={<ExportData />} />



          <Route path="/user-login" element={<UserLogin />} />
          <Route path="/user-dashboard" element={<UserDashboard />} />
          <Route path="/messages" element={<UserChat />} />
          <Route path="/admin-login/access/:email" element={<AdminLoginAccess />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/user-operation-board" element={<UserOperation />} />
          <Route path="/user-strategic-board" element={<UserStrategic />} />
          <Route path="/user-project-detail/:id/:title" element={<UserProject />} />
 
 
          <Route path="/shared-access/:token" element={<SharedAccess />} />
          <Route path="/board/:id/:title" element={<SharedAccessNew />} />

 
          
 
   
        </Routes>  
      </BrowserRouter>


    </div>
  );
}

export default App;
